<template>
  <DxChart
    id="tank-status-chart"
    :data-source="chartData"
    :size="{ width: undefined }"
    class="rounded-xl p-4 backdrop-blur w-full" style="background-color:#2b2b34;"
  >
    <DxTitle text="Current Tank Status" />
    <DxLegend vertical-alignment="bottom" horizontal-alignment="center" />

    <DxSeries
      argument-field="status"
      value-field="count"
      type="bar"
    />

    <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" />
  </DxChart>
</template>

<script setup>
import { DxChart, DxSeries, DxTitle, DxLegend, DxTooltip } from 'devextreme-vue/chart';

function customizeTooltip(info) {
  return {
    text: `${info.argumentText}: ${info.valueText}`,
  };
}

const chartData = [
  { status: 'OK',       count: 112 },
  { status: 'Warning',  count: 35  },
  { status: 'Critical', count: 7   },
];
</script>

<style scoped>
#tank-status-chart {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
}
</style>
